import axios from "axios";
import { dynamicFailed } from "../hooks/useToast";
import { headers } from "../exports/exports";

export const checkUser = async (accessToken: string) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_IDENTITY_SERVER_URL}api/user`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response;
  } catch (error) {
    // dynamicFailed("Server Error");
  }
};

export const fetchUserById = async (id: number) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-users?filters[sis_id][$eq]=${id}&populate[Profile_Picture][populate]=*&populate[Payment_Reciept][populate]=*&populate[frcsit_user_operations][populate]=*&populate[bi_frcsit_user_upload][populate]=*`,
      { headers }
    );
    return response.data.data;
  } catch (error) {
    dynamicFailed("Server Error");
  }
};
